module.exports = __webpack_public_path__ + "static/media/8.972f0e72.jpg";